import inject from "scripts/ioc/inject";
import BaseContentDetailsPageView from "scripts/views/baseContentDetailsPageView";
import ContentDetailsDocumentPageNavView from "scripts/views/contentDetailsDocumentPageNavView";

import templateContentDetailsDocumentPage from "templates/contentDetailsDocumentPage.hbs";

class ContentDetailsDocumentPageView extends BaseContentDetailsPageView {
  constructor(
    options,
    breadcrumbService = inject("breadcrumbService"),
    connectionService = inject("connectionService"),
    securityService = inject("securityService"),
    bookshelfService = inject("bookshelfService"),
  ) {
    super(
      options,
      breadcrumbService,
      connectionService,
      securityService,
      bookshelfService,
    );

    this.initializeBookshelfDeps();
  }

  get template() {
    return templateContentDetailsDocumentPage;
  }

  render() {
    super.render();
    super.renderBookshelfElements();

    return this;
  }

  createNavView() {
    const organizationProperties = this.securityService.getUser().getActiveOrganizationProperty(
        "organizationProperties",
    );

    return new ContentDetailsDocumentPageNavView({
      model: this.model,
      organizationProperties,
    });
  }
}

export default ContentDetailsDocumentPageView;
